import './styles/templates/learning-center.template.scss';

import GoBackComponent from './modules/go-back/go-back';

(function () {
  GoBackComponent.init();
})();